var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignHero(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 203,
    viewBox: "0 0 203 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.149 107.649H141.33V124.056H167.149V107.649Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M176.72 124.056H149.008V136.623H176.72V124.056Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.934 136.623H138.857V157.236H170.934V136.623Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M158.682 124.056V107.648",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.73 136.624V124.054",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.684 157.236V136.565",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M164.678 152.399V141.724",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.945 136.728C160.189 138.463 162.432 140.198 164.676 141.934C166.762 140.163 168.848 138.393 170.934 136.623",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.684 157.236C160.015 155.5 162.346 153.765 164.677 152.03C166.763 153.765 168.849 155.5 170.935 157.236",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.225 110.488C141.26 109.57 141.295 108.652 141.33 107.734C145.843 107.767 150.357 107.8 154.87 107.833C150.322 108.718 145.773 109.603 141.225 110.488Z",
    fill: "#0E171E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M149.033 127C149.068 126.082 149.103 125.164 149.138 124.246C152.784 124.235 156.43 124.224 160.076 124.213C156.395 125.142 152.714 126.071 149.033 127Z",
    fill: "#0E171E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M138.779 139.515C138.814 138.597 138.849 137.679 138.884 136.761C142.53 136.75 146.176 136.739 149.822 136.728C146.141 137.657 142.46 138.586 138.779 139.515Z",
    fill: "#0E171E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M147.455 139.699H142.039V143.038H147.455V139.699Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7715 123.348V142.959",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6086 156.31C57.4761 157.658 59.6506 158.368 62.1297 158.368H117.448C123.721 158.368 128.806 153.282 128.806 147.009V59.3877C128.806 51.472 135.068 44.9742 142.978 44.6807L62.1297 44.6265C55.8567 44.6265 50.7715 49.7117 50.7715 55.9846V93.4826",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M154.899 65.872V56.4594C154.899 49.9396 149.614 44.6543 143.094 44.6543C136.574 44.6543 131.289 49.9396 131.289 56.4594V90.0081H150.85H162.702C167.047 90.0081 170.569 86.4856 170.569 82.1402V65.872H154.899Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M153.241 52.1274C153.458 52.6231 153.627 53.0724 153.75 53.4282C152.464 53.5355 151.311 54.2873 150.701 55.4426C147.431 61.6333 142.593 70.2634 138.57 77.3507C136.559 80.8933 134.752 84.0486 133.449 86.3182C133.118 86.893 132.821 87.411 132.56 87.864V56.9956C132.733 51.5516 135.672 46.8251 140.29 45.599C144.058 44.5989 148.15 45.8194 150.852 48.4463L151.306 47.9791L150.852 48.4463C151.921 49.4855 152.712 50.9187 153.241 52.1274Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 1.30303
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6481 57.1152H65.4934C65.1734 57.1152 64.9141 57.3746 64.9141 57.6945V73.8493C64.9141 74.1692 65.1734 74.4286 65.4934 74.4286H81.6481C81.968 74.4286 82.2274 74.1692 82.2274 73.8493V57.6945C82.2274 57.3746 81.968 57.1152 81.6481 57.1152Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5898 69.6159L70.5899 69.6159L72.2104 70.4623C72.2105 70.4624 72.2106 70.4624 72.2108 70.4624C72.2708 70.467 72.3308 70.4693 72.3907 70.4693C72.9652 70.4693 73.5114 70.2591 73.9409 69.8712L73.9409 69.8712L85.1844 59.7157C85.1844 59.7157 85.1844 59.7157 85.1844 59.7156C85.6189 59.3232 85.653 58.6527 85.2604 58.2182C84.8675 57.7829 84.1971 57.7504 83.7633 58.142L83.7632 58.1421L72.5199 68.2975C72.4786 68.3347 72.4288 68.3523 72.371 68.3482C72.3154 68.3439 72.2685 68.3194 72.233 68.2759L72.233 68.2759L69.7568 65.2395L69.7568 65.2395C69.3868 64.7858 68.7191 64.7178 68.2653 65.0877L68.5784 65.4719L68.2652 65.0877C67.8114 65.4577 67.7435 66.1257 68.1136 66.5794C68.1136 66.5794 68.1136 66.5794 68.1136 66.5794L70.5898 69.6159Z",
    fill: "#6AD67D",
    stroke: "#6AD67D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2207 63.6895H109.94",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3242 67.0552H109.782H90.3242Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3242 67.0552H109.782",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110.52 101.13H97.5684",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M110.937 135.151H91.2207",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8984 105.389V96.8877",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M129.575 59.364C129.575 52.9708 133.846 47.5455 139.73 45.8469C134.733 48.2688 131.425 53.3359 131.425 59.364V146.981C131.425 151.81 128.225 155.895 123.83 157.228C127.275 155.117 129.575 151.317 129.575 146.981V59.364Z",
    fill: "#0E171E",
    stroke: "#0E171E",
    strokeWidth: 1.30303
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M154.9 61.7959L154.881 81.9189C154.877 86.3848 158.496 90.0073 162.962 90.0073",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8523 121.617L40.8079 132.011C37.9012 134.435 33.5748 134.019 31.1828 131.086C28.8138 128.181 29.2422 123.907 32.1406 121.53L50.7994 106.228",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5006 87.2373L78.2715 100.77",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7598 93.1397L98.2634 67.3037C102.817 68.83 105.202 72.4944 106.484 77.2454L96.1502 85.8626",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.682 77.3373C107.743 73.9719 108.72 70.4196 109.781 67.0542C105.769 67.0542 102.153 67.2 98.1406 67.2C99.2909 67.6023 101.353 68.489 103.501 70.9404C105.647 73.3887 106.433 76.1443 106.682 77.3373Z",
    fill: "#0E171E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8555 154.141L43.6567 142.409L39.877 154.207L37.8555 154.141Z",
    fill: "#0E171E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6908 156.386L39.4785 156.197C39.7922 154.86 40.1414 153.492 40.5298 152.095C41.51 148.579 42.621 145.326 43.788 142.343C49.5744 142.772 55.3589 143.2 61.1434 143.629C58.6208 136.965 54.2274 125.359 52.1268 119.81C54.1097 123.858 58.2717 126.643 63.0834 126.643H69.1592L69.4523 126.854C70.9143 131.108 72.3782 135.361 73.8421 139.615L73.8495 139.643",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6159 154.228C38.376 154.254 38.7379 154.266 39.9421 154.291C41.0727 150.374 42.6577 146.248 43.7882 142.331C41.8032 142.055 41.188 141.987 39.2029 141.71C38.2338 144.192 37.2992 146.322 36.3301 148.804",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4883 126.528C64.6101 127.999 67.7319 129.469 70.8537 130.939C70.2976 129.503 69.7414 128.068 69.1852 126.632C66.6196 126.597 64.0539 126.563 61.4883 126.528Z",
    fill: "#0E171E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8184 150.111H63.5423C67.0323 150.111 69.4494 146.627 68.2273 143.358C66.131 137.75 64.0347 132.142 61.9384 126.535",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M33.95 154.38L35.0264 155.533C35.6479 156.199 36.7472 156.015 37.1184 155.183L38.0987 152.987C38.4888 152.112 38.3365 151.091 37.7082 150.369L36.3023 148.869L39.3003 141.745L32.0579 141.005C32.0579 141.005 28.632 149.331 25.7637 155.752L33.95 154.38Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6067 150.446L31.8848 154.48",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3301 154.151L34.7931 150.723",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3283 149.156C31.4669 149.642 31.9959 150.959 31.51 152.098L30.1142 155.368C29.6282 156.507 28.3112 157.036 27.1726 156.55L25.7305 155.934L28.9404 148.564L30.3283 149.156Z",
    fill: "#0E171E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4941 149.459L32.0562 141.005L33.3209 141.135L29.5746 149.92L28.4941 149.459Z",
    fill: "#0E171E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8547 141.482C36.8547 141.482 35.4971 145.181 31.9766 143.045",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2566 113.485H90.1272C95.7288 113.485 99.3212 119.445 96.7034 124.399C92.7712 131.838 88.8408 139.279 84.9085 146.717L75.8844 146.927L70.4341 147.054C71.5712 144.58 72.7083 142.104 73.8454 139.63C75.8358 135.296 77.8281 130.964 79.8204 126.63H63.0793C58.2676 126.63 54.1056 123.844 52.1227 119.796C51.3291 118.179 50.8848 116.361 50.8848 114.438V113.485H76.3731",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7012 113.485C58.0464 117.289 61.2438 120.269 65.1372 120.269H87.6874C89.2217 120.269 90.2074 121.898 89.4952 123.257L78.2711 146.872",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3963 151.375L68.5879 151.49C68.5879 151.49 69.7111 148.822 70.4346 147.024C74.6479 147.003 78.9311 146.769 83.1444 146.748C82.9061 147.236 82.6505 147.726 82.3962 148.194",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5273 149.12L83.1452 146.778L70.4354 147.055L69.5273 149.12Z",
    fill: "#0E171E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3633 151.35L83.0014 149.907C83.3698 149.074 82.7693 148.135 81.8586 148.12L79.4534 148.081C78.4962 148.065 77.6167 148.606 77.1989 149.468L76.3712 151.35L68.6428 151.389L65.7715 158.34C65.7715 158.34 79.8077 158.223 86.839 158.34L82.3633 151.35Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8809 153.21H83.2673",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3969 152.01H78.6699",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9805 156.73C78.9805 155.492 79.984 154.489 81.222 154.489H84.7775C86.0155 154.489 87.0191 155.492 87.0191 156.73V158.298L78.9805 158.239V156.73Z",
    fill: "#0E171E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9783 158.298L65.7715 158.34L66.407 157.123H79.9783V158.298Z",
    fill: "#0E171E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9629 153.033C67.9629 153.033 71.9563 153.046 71.3739 157.123",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5669 89.4383C63.3238 90.2113 64.7449 89.9455 65.4323 89.7203C65.711 89.6291 65.9194 89.3966 65.976 89.1089C66.1826 88.0586 66.2164 86.9443 66.1517 85.8658L66.7197 85.4272C66.8865 85.2984 66.9156 85.058 66.7843 84.8931L65.9155 83.8016C65.5441 81.5455 64.9151 79.8214 64.9151 79.8214C64.9151 79.8214 56.9082 77.7916 58.1062 87.5416L56.9082 90.1926L63.264 91.0522L63.373 90.036",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M59.625 84.5029C59.6564 84.6039 59.7429 84.8346 59.9672 85.0347C60.1896 85.2332 60.4265 85.2934 60.5303 85.3135",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6816 85.6396C63.7226 85.7402 63.8239 85.9493 64.0464 86.1222C64.3177 86.333 64.6035 86.361 64.7096 86.3661",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M63.373 83.5501C63.5093 83.8597 63.8424 84.0163 64.1309 83.932C64.3615 83.8647 64.5349 83.6521 64.5683 83.3945",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3744 79.9321C63.3744 79.9321 63.3744 81.8011 61.1678 81.3725C60.8587 81.3125 60.5521 81.5027 60.4728 81.8074C60.3582 82.2477 60.3797 82.946 61.058 83.8587C61.058 83.8587 61.1856 84.4235 60.0702 83.7533C59.7307 83.5494 59.3055 83.513 58.9577 83.7025C58.5621 83.918 58.2458 84.3651 58.7509 85.2906C58.7509 85.2906 59.1946 85.9773 59.8379 86.2324L58.1297 87.6411C58.1297 87.6411 53.4156 81.8843 58.4736 78.6897C58.4736 78.6897 61.6681 76.793 64.43 78.0908C64.43 78.0908 65.3051 78.5899 65.262 79.322C65.262 79.322 65.1306 80.4257 63.3744 79.9321Z",
    fill: "#0E171E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4405 113.447C89.3985 113.551 85.5804 116.941 82.2089 116.01C80.3874 115.508 77.556 115.153 76.496 113.394C76.1618 113.39 76.1603 113.39 75.8262 113.386C76.0324 113.719 78.567 117.654 83.4246 117.855C88.6349 118.071 91.5462 113.785 91.6859 113.571C91.0425 113.564 90.0838 113.455 89.4405 113.447Z",
    fill: "#0E171E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2617 118.971L35.3023 116.204C35.3231 114.786 35.7819 113.409 36.6159 112.263L48.9662 95.2822C50.538 93.1211 53.146 91.9663 55.8026 92.255L56.7396 90.0366L63.3616 90.9363L63.1287 92.7665C66.9349 92.868 71.4829 94.4266 74.2292 97.064L82.8966 105.388L89.0884 96.12L95.8523 102.174L90.5637 111.63C87.995 116.224 81.9881 117.537 77.7372 114.434L70.8538 109.411V113.486H50.7831L50.7999 106.228L35.2617 118.971Z",
    fill: "#6AD67D",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8848 110.456L70.8532 110.791",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9492 113.486V110.534",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5648 113.486C55.5456 112.416 55.531 111.604 55.5117 110.534",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6875 113.486C66.6941 112.489 66.6987 111.788 66.7053 110.791L66.6875 113.486Z",
    fill: "#0E171E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6875 113.486C66.6941 112.489 66.6987 111.788 66.7053 110.791",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2439 113.486C68.2176 112.558 68.2703 111.719 68.2439 110.791",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M65.918 104.935C67.5631 106.427 69.2082 107.919 70.8533 109.411",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2357 106.887C83.6812 106.284 83.1268 105.681 82.5723 105.079",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8008 106.228V103.017",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7598 99.1972C97.4917 98.1066 97.8718 97.4044 98.5741 95.9435C99.2181 94.6037 99.4564 94.1385 99.5994 93.5575C99.7965 92.7569 100.179 91.2025 99.3628 89.8306C99.0451 89.2966 98.6813 88.9666 98.3974 88.7622",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M97.944 92.9059C98.1896 92.4352 99.1576 90.455 98.3186 88.5677C98.1985 88.2975 98.0265 87.9957 97.7754 87.688",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1331 91.6633C97.2555 91.4317 98.6658 88.6704 97.3105 86.635C97.1179 86.3457 96.708 85.7825 96.1504 85.6851",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8521 90.8947C96.1326 90.3675 96.4838 89.5391 96.562 88.4889C96.6913 86.7525 96.0355 84.9267 95.5366 84.9395C95.2258 84.9475 95.178 85.6638 94.3337 87.641C93.3448 89.9571 92.8406 90.3086 92.421 90.4017C91.9149 90.5139 91.4289 90.2729 91.1115 90.0647C90.8477 90.2846 90.584 90.5045 90.3203 90.7244C90.4882 91.0787 90.6536 91.5163 90.7631 92.0304C90.8897 92.624 90.9115 93.1775 90.8795 93.665",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0488 90.036L94.3529 87.3618L93.5416 89.3592C93.2119 90.1875 92.2591 90.575 91.4448 90.2119L91.0488 90.036Z",
    fill: "#0E171E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0371 96.197C89.5867 95.3299 90.1364 94.4628 90.686 93.5957C93.1246 95.8502 95.5632 98.1048 98.0018 100.359C97.4909 101.121 96.98 101.882 96.4691 102.643C93.9918 100.495 91.5144 98.3458 89.0371 96.197Z",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3984 100.801C94.9111 100.006 95.3397 99.3412 95.8524 98.5459",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5195 99.1954C93.0059 98.4066 93.4923 97.6179 93.9787 96.8291",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4492 97.4235C91.0207 96.6078 91.5922 95.7922 92.1637 94.9766",
    stroke: "#0E171E",
    strokeWidth: 1.30303,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignHero);
export default __webpack_public_path__ + "static/media/sign-hero.f3f60aef1b03be4b6679e84aa5ac5d94.svg";
export { ForwardRef as ReactComponent };